import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { ChatMessageDto } from '../models/dto/chat-message.dto';
import { environment } from '../../config/environments/environment';

@Injectable()
export class ChatsMessagesService {
  private readonly path = 'chatsmessages';

  constructor(private httpClient: HttpClient) {}

  get(): Observable<ChatMessageDto[]> {
    return this.httpClient.get<ChatMessageDto[]>(
      `${environment.api.baseUrl}/${this.path}`
    );
  }

  getUsersMessagesByName(firstName: String): Observable<ChatMessageDto[]> {
    return this.httpClient.get<ChatMessageDto[]>(
      `${environment.api.baseUrl}/${this.path}/q`,
      { params: { firstname: `${firstName}` } }
    );
  }

  getTotalUnreadMessages(): Observable<number> {
    return this.httpClient.get<number>(
      `${environment.api.baseUrl}/${this.path}/total-unread-messages`
    );
  }
}
